// Components
import { TabDrawerLayout } from '@Components/shared/layouts/TabDrawerLayout';
import { DrawerHeaderLayout } from '@Components/shared/layouts/DrawerHeaderLayout';
import { SetupCampaignHeader } from './SetupCampaignHeader';
import { Controller, FormProvider } from 'react-hook-form';

// Redux
import { useCampaignDrawer } from '@Modal/hooks/campaigns/useCampaignDrawer';
import { SetupCampaignDrawerFooter } from './SetupCampaignDrawerFooter';
import { useSetupCampaignForm } from '@Forms/campaign/SetupCampaignFormContext';
import { Stack, TextField } from '@mui/material';
import { RHFTextField, RHFDatePicker } from '@Components/hook-form';
import { useMemo } from 'react';

const formatToLocalDateTime = (input?: string | Date | null) => {
  if (!input) {
    return '';
  }

  const date = new Date(input);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const SetupCampaignContent: React.FC = () => {
  const { handleCreateCancel, submittable, handleSubmitGeneralForm, selectedCampaignData } =
    useCampaignDrawer();
  const methods = useSetupCampaignForm();

  const minDate = useMemo(() => {
    const now = new Date();
    now.setSeconds(0, 0);
    return formatToLocalDateTime(now);
  }, []);

  return (
    <TabDrawerLayout
      header={
        <DrawerHeaderLayout currentSlug="/campaigns" onClose={handleCreateCancel}>
          <SetupCampaignHeader />
        </DrawerHeaderLayout>
      }
      footer={
        <SetupCampaignDrawerFooter
          //   onDeleteClick={() => dispatch(setShowDeleteCampaignModal(true))}
          onSaveClick={handleSubmitGeneralForm}
          saveDisabled={!submittable}
          onCancelClick={handleCreateCancel}
        />
      }
    >
      <FormProvider {...methods}>
        <Stack direction="column" spacing={2} margin={2}>
          <RHFTextField name="description" label="Description" type="text" disabled={true} />
          <RHFDatePicker name="startDate" label="Start Date" disabled={true} />
          <Controller
            name="endDate"
            control={methods.control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                size="small"
                label="End Date & Time"
                type="datetime-local"
                data-at-text-field="SetupCampaignEndDate"
                value={formatToLocalDateTime(field.value)}
                onChange={(event) =>
                  field.onChange(event.target.value ? new Date(event.target.value) : null)
                }
                fullWidth
                disabled={selectedCampaignData.status !== 'ACTIVE'}
                error={!!error}
                helperText={error?.message}
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: minDate }}
              />
            )}
          />
          <RHFTextField name="status" label="Status" type="text" disabled={true} />
        </Stack>
      </FormProvider>
    </TabDrawerLayout>
  );
};
